import {
    collection,
    addDoc,
    getDocs,
    getDoc,
    doc,
    updateDoc,
    deleteDoc,
    query,
    where,
    serverTimestamp,
} from "firebase/firestore";

import { db } from "../firebase/firebaseConfig";

const booksRef = collection(db, "books");

export const createBook = async (bookData) => {
    try {
        const docRef = await addDoc(booksRef, {
            ...bookData,
            status: "draft",
            createdAt: serverTimestamp(),
        });

        return docRef.id;
    } catch (error) {
        throw error;
    }
};

export const getBooksByUser = async (uid) => {
    try {
        const q = query(
            booksRef,
            where("userId", "==", uid)
        );

        const snapshot = await getDocs(q);

        const books = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        // Sort client-side descending by createdAt
        return books.sort((a, b) => {
            const timeA = a.createdAt?.seconds ? a.createdAt.seconds * 1000 : 0;
            const timeB = b.createdAt?.seconds ? b.createdAt.seconds * 1000 : 0;
            return timeB - timeA;
        });
    } catch (error) {
        throw error;
    }
};

export const getBookById = async (bookId) => {
    const bookDoc = await getDoc(doc(db, "books", bookId));

    if (!bookDoc.exists()) return null;

    return {
        id: bookDoc.id,
        ...bookDoc.data(),
    };
};

export const updateBook = async (bookId, data) => {
    await updateDoc(doc(db, "books", bookId), data);
};

export const deleteBook = async (bookId) => {
    await deleteDoc(doc(db, "books", bookId));
};

export const getAllBooks = async () => {
    try {
        const snapshot = await getDocs(booksRef);
        const books = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
        }));

        // Sort client-side descending by createdAt
        return books.sort((a, b) => {
            const timeA = a.createdAt?.seconds ? a.createdAt.seconds * 1000 : 0;
            const timeB = b.createdAt?.seconds ? b.createdAt.seconds * 1000 : 0;
            return timeB - timeA;
        });
    } catch (error) {
        console.error("Error fetching all books:", error);
        throw error;
    }
};

export const addReviewComment = async (bookId, comment) => {
    try {
        const bookRef = doc(db, "books", bookId);
        const bookSnap = await getDoc(bookRef);
        if (!bookSnap.exists()) return;

        const currentData = bookSnap.data();
        const currentComments = currentData.comments || [];
        
        const newComment = {
            ...comment,
            id: Math.random().toString(36).substring(2, 9),
            createdAt: new Date().toISOString()
        };

        await updateDoc(bookRef, {
            comments: [...currentComments, newComment]
        });
        return newComment;
    } catch (error) {
        console.error("Error adding review comment:", error);
        throw error;
    }
};
